 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"styles","3":"component---src-pages-404-js","4":"component---src-pages-about-cookie-policy-js","5":"component---src-pages-about-privacy-policy-js","6":"component---src-pages-campaigns-index-js","7":"component---src-pages-campaigns-view-campaign-js","8":"component---src-pages-case-study-index-js","9":"component---src-pages-contact-index-js","10":"component---src-pages-customers-index-js","11":"component---src-pages-dashboard-index-js","12":"component---src-pages-demos-custom-demo-js","13":"component---src-pages-demos-index-js","14":"component---src-pages-demos-manage-demo-modal-js","15":"component---src-pages-industries-banking-insurance-js","16":"component---src-pages-industries-communications-services-js","17":"component---src-pages-industries-index-del-js","18":"component---src-pages-industries-index-js","19":"component---src-pages-industries-industrial-manufacturing-js","20":"component---src-pages-industries-retail-distribution-js","21":"component---src-pages-login-index-js","22":"component---src-pages-register-index-js","23":"component---src-pages-resources-case-studies-js","24":"component---src-pages-resources-featured-demos-js","25":"component---src-pages-resources-index-js","26":"component---src-pages-services-ai-assistant-services-js","27":"component---src-pages-services-applications-development-js","28":"component---src-pages-services-enterprise-bi-and-analytics-js","29":"component---src-pages-services-gen-ai-services-js","30":"component---src-pages-services-index-del-js","31":"component---src-pages-services-index-js","32":"component---src-pages-services-planning-and-budgeting-js","33":"component---src-pages-services-professional-services-advanced-analytics-js","34":"component---src-pages-services-professional-services-advanced-visualizations-js","35":"component---src-pages-services-professional-services-cognos-analytics-js","36":"component---src-pages-services-professional-services-data-warehousing-js","37":"component---src-pages-services-professional-services-js","38":"component---src-pages-services-professional-services-planning-analytics-js","39":"component---src-pages-services-watson-assistant-services-js","40":"component---src-pages-services-watson-discovery-services-js","41":"component---src-pages-services-watsonx-orchestrate-js","42":"component---src-pages-services-watsonx-platform-services-js","43":"component---src-pages-solutions-ai-for-customer-care-js","44":"component---src-pages-solutions-ai-for-employee-care-js","45":"component---src-pages-solutions-human-resource-services-js","46":"component---src-pages-solutions-index-del-js","47":"component---src-pages-solutions-index-js","48":"component---src-pages-solutions-it-service-desk-js","49":"component---src-pages-solutions-mass-tort-service-js","50":"component---src-pages-solutions-planning-analytics-service-js","51":"component---src-pages-solutions-reseller-distributor-service-js","52":"component---src-pages-solutions-sales-support-solutions-js","53":"component---src-pages-why-incede-index-js","54":"component---src-pages-why-incede-why-incede-sub-items-certified-expertise-js","55":"component---src-pages-why-incede-why-incede-sub-items-customer-success-js","56":"component---src-pages-why-incede-why-incede-sub-items-leader-ship-team-js","57":"component---src-pages-why-incede-why-incede-sub-items-results-in-business-terms-js","58":"component---src-pages-why-incede-why-incede-sub-items-technology-partners-js","59":"component---src-templates-about-page-js","60":"component---src-templates-case-study-js","61":"component---src-templates-index-page-js","62":"component---src-templates-industries-js","63":"component---src-templates-resources-case-studies-js","64":"component---src-templates-services-js","65":"component---src-templates-solutions-post-js"}[chunkId]||chunkId) + "-" + {"1":"fc223be7119363967c1c","3":"54bd487522e591f141b9","4":"aec618360827f1fc8f98","5":"e6880f2c08973f97a867","6":"920306bc6e432b791a8c","7":"b1b3788ac0b40af19ef0","8":"eca45bda4e9bf94cd158","9":"8316cede851a42802627","10":"3816cc116299094e51da","11":"325b48be54d9fd3e1887","12":"d3541c17ee917b5521a0","13":"809c3026f586b10bfec9","14":"1d3cd6dced0f917016f8","15":"2778b697442608e9e311","16":"5475b10d2f32c743e7b0","17":"b94261a6345bf075fada","18":"fa55ae1ee1e61d0266ee","19":"ee2e42b6744e79b20d9c","20":"07e2e45f7d85b5ff2eae","21":"c9a8f3f1812cc5cef7da","22":"5dc649bad1ba9be0dcb3","23":"1499d3fd03390aa35e44","24":"fd05a88ea8b1ee3b85ff","25":"df781f590112af417844","26":"d56ced291622ca36eb3c","27":"32a9971a2420420e5990","28":"fa8a57017b535ae8062d","29":"0e652cd72b741bf71716","30":"aba715238c45d7b80abf","31":"9b833b272f49061c18a5","32":"8ca1ffd2b52df918fdce","33":"5cc410356ac8c0559497","34":"69b476e46630438106c9","35":"48d47e3c4a693872aae0","36":"a686c07d148bd2450495","37":"e59e307bba55113b7d98","38":"962923afeefae9807129","39":"b44368a4b4c26936bb7e","40":"4d206de7ad25331e772f","41":"6c6fb30f1d2437a7ef43","42":"8ec085864e584e9a5759","43":"f7f13dc93606aad35aa6","44":"cdafdccf0a8d413aa21f","45":"1b26e5bc8f2c808512af","46":"e3b9ddb3a9af2747128b","47":"2765eae6f16e344b31c8","48":"1ae5e557f56da9ab0d4f","49":"ebf0a291e97f80440aea","50":"dbeed58ba4459d4732f6","51":"b9f0ebab6ea7a00f0eb3","52":"3a97556ab5a06bf8a2ea","53":"19a777ef1979e04f2b4d","54":"5056768f4af92f5e244d","55":"297ccb9ec971a3b7cdd7","56":"7af9d031bbcea7860239","57":"e8872acd9625fa19ea04","58":"018bbd70352d1ff4bca5","59":"0f3bab1fb3401f96931b","60":"ad7afd2c5abb4df2cf93","61":"26e1224b9ac8f503cb3d","62":"a9a40b41504338582e2f","63":"1d3e49e4b57a300a1c9e","64":"b170e488003eef3ac4c9","65":"d2b05deecd8c7d5a4521"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"styles","3":"component---src-pages-404-js","4":"component---src-pages-about-cookie-policy-js","5":"component---src-pages-about-privacy-policy-js","6":"component---src-pages-campaigns-index-js","7":"component---src-pages-campaigns-view-campaign-js","8":"component---src-pages-case-study-index-js","9":"component---src-pages-contact-index-js","10":"component---src-pages-customers-index-js","11":"component---src-pages-dashboard-index-js","12":"component---src-pages-demos-custom-demo-js","13":"component---src-pages-demos-index-js","14":"component---src-pages-demos-manage-demo-modal-js","15":"component---src-pages-industries-banking-insurance-js","16":"component---src-pages-industries-communications-services-js","17":"component---src-pages-industries-index-del-js","18":"component---src-pages-industries-index-js","19":"component---src-pages-industries-industrial-manufacturing-js","20":"component---src-pages-industries-retail-distribution-js","21":"component---src-pages-login-index-js","22":"component---src-pages-register-index-js","23":"component---src-pages-resources-case-studies-js","24":"component---src-pages-resources-featured-demos-js","25":"component---src-pages-resources-index-js","26":"component---src-pages-services-ai-assistant-services-js","27":"component---src-pages-services-applications-development-js","28":"component---src-pages-services-enterprise-bi-and-analytics-js","29":"component---src-pages-services-gen-ai-services-js","30":"component---src-pages-services-index-del-js","31":"component---src-pages-services-index-js","32":"component---src-pages-services-planning-and-budgeting-js","33":"component---src-pages-services-professional-services-advanced-analytics-js","34":"component---src-pages-services-professional-services-advanced-visualizations-js","35":"component---src-pages-services-professional-services-cognos-analytics-js","36":"component---src-pages-services-professional-services-data-warehousing-js","37":"component---src-pages-services-professional-services-js","38":"component---src-pages-services-professional-services-planning-analytics-js","39":"component---src-pages-services-watson-assistant-services-js","40":"component---src-pages-services-watson-discovery-services-js","41":"component---src-pages-services-watsonx-orchestrate-js","42":"component---src-pages-services-watsonx-platform-services-js","43":"component---src-pages-solutions-ai-for-customer-care-js","44":"component---src-pages-solutions-ai-for-employee-care-js","45":"component---src-pages-solutions-human-resource-services-js","46":"component---src-pages-solutions-index-del-js","47":"component---src-pages-solutions-index-js","48":"component---src-pages-solutions-it-service-desk-js","49":"component---src-pages-solutions-mass-tort-service-js","50":"component---src-pages-solutions-planning-analytics-service-js","51":"component---src-pages-solutions-reseller-distributor-service-js","52":"component---src-pages-solutions-sales-support-solutions-js","53":"component---src-pages-why-incede-index-js","54":"component---src-pages-why-incede-why-incede-sub-items-certified-expertise-js","55":"component---src-pages-why-incede-why-incede-sub-items-customer-success-js","56":"component---src-pages-why-incede-why-incede-sub-items-leader-ship-team-js","57":"component---src-pages-why-incede-why-incede-sub-items-results-in-business-terms-js","58":"component---src-pages-why-incede-why-incede-sub-items-technology-partners-js","59":"component---src-templates-about-page-js","60":"component---src-templates-case-study-js","61":"component---src-templates-index-page-js","62":"component---src-templates-industries-js","63":"component---src-templates-resources-case-studies-js","64":"component---src-templates-services-js","65":"component---src-templates-solutions-post-js"}[chunkId]||chunkId) + "." + {"1":"a2e49e16380a160658f0","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
